import { render, staticRenderFns } from "./import-clients.vue?vue&type=template&id=24d5aabb&scoped=true"
import script from "./import-clients.vue?vue&type=script&lang=js"
export * from "./import-clients.vue?vue&type=script&lang=js"
import style0 from "./import-clients.vue?vue&type=style&index=0&id=24d5aabb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d5aabb",
  null
  
)

export default component.exports